import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  createProjectDetails,
  createSubContractor,
} from "../../../webServices/Apis";
import Loader from "../../Loader/Loader";

const AddProject = ({
  showAddProject,
  action,
  setAction,
  setShowAddProject,
  domains,
}) => {
  const [open, setOpen] = useState(showAddProject);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([{ taskName: "", taskBudget: "" }]);

  const formik = useFormik({
    initialValues: {
      projectNumber: "",
      projectName: "",
      projectDescription: "",
      startDate: "",
      dueDate: "",
      budget: "",
      tasks: [],
      projectAddress: "",

    },
    validationSchema: Yup.object({
      projectNumber: Yup.number().typeError("Project number should only be numeric").required("Project number is required").test(
        "max-digits", // Test name
        "Project number cannot be more than 20 digits", // Error message
        (value) => value && value.toString().length <= 20 // Validation logic
      ),
      projectName: Yup.string().required("Project name is required").max(50, "Project name can not be more than 50 characters"),
      // description: Yup.string().required("Description is required"),
      startDate: Yup.string().required("Project start date is required"),
      dueDate: Yup.string().required("Project end date is required"),
      budget: Yup.number().typeError("Project budget should only be numeric").required("Project budget is required").moreThan(0, "Budget cannot be zero"),
      projectAddress: Yup.string().required("Project address is required").max(200, "Address can not be more than 200 characters"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      setLoading(true);
      try {
        const payload = { ...values, tasks: tasks
          .filter(task => task.taskName.trim() !== "" && task.taskBudget.trim() !== "")}
       
        if(payload.tasks.length < 1){
          message.error("Project should contain atleast one task")
          return;
        }

        
        const response = await createProjectDetails(payload);
        if (response?.data?.success) {
          message.success(response.data.message || "Project created successfully!");
          setAction(!action);
          setShowAddProject(!showAddProject);
        }

        resetForm();
      } catch (error) {
        message.error(error.response.data.message || "Failed to create project");
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  // Function to add a new task field
  const addTask = () => {
    setTasks([...tasks, { taskName: "", taskBudget: "" }]);
  };

  // Function to handle task input change
  const handleTaskChange = (index, event) => {
    const {name, value} = event.target
    const newTasks = [...tasks];
    newTasks[index][name] = value
    setTasks(newTasks);
  };

  // Function to remove a task field
  const removeTask = (index) => {
    const newTasks = tasks.filter((_, i) => i !== index);
    setTasks(newTasks);
  };

  return (
    <>

      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white  rounded-2xl shadow-lg w-[700px] h-[700px] overflow-y-scroll scrollbar-hidden">
          {loading && (
            <Loader/>
          )}
          <h3 className="text-xl font-bold mb-4 text-center bg-blue-950 py-3 text-white">Create Project</h3>
          <form onSubmit={formik.handleSubmit} className="space-y-6 p-8">
            <div className="flex gap-2">
              <div className='w-full'>
                <label htmlFor="number" className="block text-sm font-medium text-gray-700">
                  Project Number
                </label>
                <input
                  type="rel"
                  name="projectNumber"
                  placeholder="Project Number"
                  value={formik.values.projectNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                />
                {formik.touched.projectNumber && formik.errors.projectNumber ? (
                  <p className="text-red-600">{formik.errors.projectNumber}</p>
                ) : null}
              </div>

              <div className=' w-full'>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Project Name
                </label>
                <input
                  type="text"
                  name="projectName"
                  placeholder="Project Name"
                  value={formik.values.projectName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                />
                {formik.touched.projectName && formik.errors.projectName ? (
                  <p className="text-red-600">{formik.errors.projectName}</p>
                ) : null}
              </div>
            </div>

            <div className='w-full'>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                Description
              </label>
              <textarea
              name="projectDescription"
              placeholder="Project Description"
              className="border border-gray-800 p-2 w-full"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.projectDescription}
              rows={4}
            />
              {formik.touched.projectDescription && formik.errors.projectDescription ? (
                <p className="text-red-600">{formik.errors.projectDescription}</p>
              ) : null}
            </div>

            <div className=' w-full'>
              <label htmlFor="projectAddress" className="block text-sm font-medium text-gray-700">
                Project Address
              </label>
              <input
                type="text"
                name="projectAddress"
                placeholder="Project Address"
                value={formik.values.projectAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                className={`block w-full p-3 border border-gray-800 rounded-md`}
              />
              {formik.touched.projectAddress && formik.errors.projectAddress ? (
                <p className="text-red-600">{formik.errors.projectAddress}</p>
              ) : null}
            </div>


            <div className=' w-full'>
              <label htmlFor="budget" className="block text-sm font-medium text-gray-700">
                Budget
              </label>
              <input
                type="rel"
                name="budget"
                placeholder="Project Budget"
                value={formik.values.budget}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                className={`block w-full p-3 border border-gray-800 rounded-md`}
              />
              {formik.touched.budget && formik.errors.budget ? (
                <p className="text-red-600">{formik.errors.budget}</p>
              ) : null}
            </div>

            <div className="flex gap-2">
              <div className=' w-full'>
                <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                  Start Date:
                </label>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Project Start Date"
                  value={formik.values.startDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                  // min={new Date().toISOString().split("T")[0]}

                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                />
                {formik.touched.startDate && formik.errors.startDate ? (
                  <p className="text-red-600">{formik.errors.startDate}</p>
                ) : null}
              </div>

              <div className=' w-full '>
                <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                  End Date:
                </label>
                <input
                  type="date"
                  name="dueDate"
                  placeholder="Project End Date"
                  value={formik.values.dueDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // min={new Date().toISOString().split("T")[0]}

                  required
                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                />
                {formik.touched.dueDate && formik.errors.dueDate ? (
                  <p className="text-red-600">{formik.errors.dueDate}</p>
                ) : null}
              </div>
            </div>



            {tasks.map((taskItem, index) => (
              <div className="mb-4" key={index}>
                <label className="block mb-1">Task {index + 1}:</label>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    name="taskName"
                    placeholder="Enter the task name"
                    className="border border-gray-800 p-2 w-full"
                    value={taskItem.taskName}
                    onChange={(e) => handleTaskChange(index, e)}
        
                  />
                  {/* <div className="ml-2">
                  <label className="block mb-1">Task Budget</label> */}
                  <input
                    type="text"
                    name="taskBudget"
                    placeholder="Enter the task budget"
                    className="border border-gray-800 p-2 w-full"
                    value={taskItem.taskBudget}
                    onChange={(e) => handleTaskChange(index, e)}
        
                  />
                  {/* </div> */}
                  <Button
                    type="danger"
                    onClick={() => removeTask(index)}
                    className="border border-gray-800 ml-2"
                  >
                    Remove
                  </Button>
                </div>
              </div>
            ))}

            <Button type="dashed" onClick={addTask}
            className="border border-gray-800"
            >
              Add Task
            </Button>


            <div className="flex justify-center gap-6 mt-16">

              <button type="button" onClick={() => {
                setShowAddProject(false)
                setOpen(false)
              }} className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>

              <button type="submit" onClick={formik.handleSubmit} className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                {formik.isSubmitting ? "Creating.." : "Create"}
              </button>

            </div>
          </form>

        </div>
      </div>



      {/* <Modal
        title="Add Project"
        open={open}
        onCancel={() => {
          setShowAddProject(false);
          setOpen(false);
          
        }}
        footer={[
          <Button key="cancel" 
          onClick={() => {
            setShowAddProject(false)
            setOpen(false)}}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={formik.handleSubmit}
          >
            {formik.isSubmitting ? "Creating.." : "Create"}
          </Button>,
        ]}
        centered
        bodyStyle={{
          maxHeight: "500px",
          overflowY: "scroll",
        }}
      >
        <form onSubmit={formik.handleSubmit} className="space-y-4"> */}
      {/* Name */}
      {/* <div className="mb-4">
            <label className="block mb-1">Name:</label>
            <input
              type="text"
              name="name"
              className="border p-2 w-full"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
            />
            {formik.touched.name && formik.errors.name ? (
              <p className="text-red-600">{formik.errors.name}</p>
            ) : null}
          </div> */}

      {/* Description */}
      {/* <div className="mb-4">
            <label className="block mb-1">Description:</label>
            <textarea
              name="description"
              className="border p-2 w-full"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.description}
              rows={4}
            />
            {formik.touched.description && formik.errors.description ? (
              <p className="text-red-600">{formik.errors.description}</p>
            ) : null}
          </div> */}

      {/* Status */}
      {/* <div className="mb-4">
            <label className="block mb-1">Status:</label>
            <select
              name="status"
              className="border p-2 w-full"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.status}
            >
              <option value="">Select Status</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
              <option value="On Hold">On Hold</option>
            </select>
            {formik.touched.gender && formik.errors.gender ? (
              <p className="text-red-600">{formik.errors.gender}</p>
            ) : null}
          </div> */}
      {/* Due Date */}
      {/* <div className="mb-4">
            <label className="block mb-1">Due Date:</label>
            <input
              type="date"
              name="dueDate"
              className="border p-2 w-full"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.dueDate}
            />
            {formik.touched.dueDate && formik.errors.dueDate ? (
              <p className="text-red-600">{formik.errors.dueDate}</p>
            ) : null}
          </div> */}

      {/* Budget */}
      {/* <div className="mb-4">
            <label className="block mb-1">Budget:</label>
            <input
              type="number"
              name="budget"
              className="border p-2 w-full"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.budget}
            />
            {formik.touched.budget && formik.errors.budget ? (
              <p className="text-red-600">{formik.errors.budget}</p>
            ) : null}
          </div> */}

      {/* Remaining Budget */}
      {/* <div className="mb-4">
            <label className="block mb-1">Remaining Budget:</label>
            <input
              type="number"
              name="remainingBudget"
              className="border p-2 w-full"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.remainingBudget}
            />
            {formik.touched.remainingBudget && formik.errors.remainingBudget ? (
              <p className="text-red-600">{formik.errors.remainingBudget}</p>
            ) : null}
          </div> */}

      {/* Domain Name */}

      {/* {domains.length > 0 && (
            <div className="mb-4">
              <label className="block mb-1">Domain:</label>
              <select
                name="domainName"
                className="border p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.domainName}
              >
                <option value="">Select Domain</option>
                {domains.map((each) => (
                  <option value={each.domainName}>{each.domainName}</option>
                ))}
              </select>
              {formik.touched.gender && formik.errors.gender ? (
                <p className="text-red-600">{formik.errors.gender}</p>
              ) : null}
            </div>
          )}
          {formik.touched.domainName && formik.errors.domainName ? (
            <p className="text-red-600">{formik.errors.domainName}</p>
          ) : null} */}

      {/* Dynamic Task Fields */}
      {/* {tasks.map((taskItem, index) => (
            <div className="mb-4" key={index}>
              <label className="block mb-1">Task {index + 1}:</label>
              <div className="flex">
                <input
                  type="text"
                  name={`task-${index}`}
                  className="border p-2 w-full"
                  value={taskItem.task}
                  onChange={(e) => handleTaskChange(index, e)}
                />
                <Button{tasks.map((taskItem, index) => (
            <div className="mb-4" key={index}>
              <label className="block mb-1">Task {index + 1}:</label>
              <div className="flex">
                <input
                  type="text"
                  name={`task-${index}`}
                  className="border p-2 w-full"
                  value={taskItem.task}
                  onChange={(e) => handleTaskChange(index, e)}
                />
                <Button
                  type="danger"
                  onClick={() => removeTask(index)}
                  className="ml-2"
                >
                  Remove
                </Button>
              </div>
            </div>
          ))}

                  onClick={() => removeTask(index)}
                  className="ml-2"
                >
                  Remove
                </Button>
              </div>
            </div>
          ))}

          <Button type="dashed" onClick={addTask}>
            Add Task
          </Button>
        </form>
      </Modal> */}
    </>
  );
};

export default AddProject;
